<template>
  <div>
    {{ currentWorkflow.status.description }}
    <span v-if="currentWorkflow.transitions">
      <br />

      <v-btn small style="margin: 0px;" @click.stop="$emit('openworkflow')" outline color="indigo">
        <span>{{ currentWorkflow.transitions.description }}</span>

        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/configuration";

export default {
  props: {
    status: {
      type: [String, Number],
      default: "0"
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters(api.namespace, [api.getters.audit]),
    statusId() {
      console.assert(
        typeof this.status === "string",
        "expect status from type string"
      );
      return String(this.status);
    },
    currentWorkflow() {
      const workflow = this.audit.workflow;
      const start_status = workflow.status.find(status => status.start);
      console.assert(start_status);

      const status_id = this.statusId;
      const status =
        workflow.status.find(status => status.id === status_id) || start_status;
      console.log("Workflow", status);
      const transitions = workflow.transitions.find(
        transition => transition.id === status_id
      );
      console.assert(transitions);
      const result = { status, transitions };
      console.log("currentWorkflow", result);
      return result;
    }
  }
};
</script>
